export default {
    createNewVisitor: 'Create New Visitor',
    updateVisitor: 'Edit Visitor Profile',
    accessInformation: 'Access Information',
    change: 'Change',
    msgImageSize: 'Image size must between 25kb and 200kb',
    msgErrorImageSize: 'Image size can not be less than 25KB or more than 200KB',
    cancel: 'Cancel',
    save: 'Save',
    name: 'Name',
    surname: 'Surname',
    profile: 'Profile',
    citizenId: 'Citizen ID/Passport ID',
    gender: 'Gender',
    male: 'Male',
    female: 'Female',
    email: 'Email Address',
    phoneNumber: 'Phone Number',
    statusStart: 'Start Date',
    statusEnd: 'End Date',
    timeStart: 'Start Time',
    timeEnd: 'End Time',
    active: 'Active',
    deactive: 'Deactive',
    msgError: 'Error Message',
    congratulation: 'Congratulation',
    warning: 'Warning',
    error: 'Error',
    endDateIsPassed: 'End Date is passed',
    msgRequiredField: 'This field is required',
    msgExceededField: 'This field is exceeded 255 characters',
    msgRequiredEmail: 'E-mail is required',
    msgInvalidEmailFormat: 'Invalid e-mail format',
    msgExceededEmail: 'E-mail is exceeded 255 characters',
    cardNo: 'Card No',
    msgExceededCardNo: 'Card No is exceeded 10 characters',
    msgImageSizeZkt: 'Image size must between 50KB and 400KB',
    msgErrorImageSizeZkt: 'Image size can not be less than 50KB or more than 400KB'
}
